import React from 'react';
import { FormLabel, Typography } from '@material-ui/core';

import { colors } from '../../../theme';

type Props = {
  children: React.ReactNode;
  bold?: boolean;
};

const BlueFormLabel = ({ bold = false, children }: Props): JSX.Element => {
  return (
    <FormLabel>
      <Typography
        data-testid="form-label"
        variant={bold ? 'body1' : 'caption'}
        style={{ color: colors.silver }}
      >
        {children}
      </Typography>
    </FormLabel>
  );
};

export default BlueFormLabel;
